export default __webpack_public_path__ + "static/1950-89f2e3cc4580ea8708abd76e5b7cffc0.gif";